import { render } from "./PhotoLoader.vue?vue&type=template&id=c0bfefc2"
import script from "./PhotoLoader.vue?vue&type=script&lang=js"
export * from "./PhotoLoader.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__